// Interface cho từng vị trí ký
// Interface cho thông tin ký trên từng trang
export interface SignaturePage {
  // trang số mấy cần ký
  page: number;
  id: number;
  key: string;
  x: number;
  y: number;
  width: number;
  height: number;
  //base 64
  files: string;
  idListStepSign?: number;
  keyListStepSign?: string;
  namefilefrist: string;
  issign?: boolean;
  datesign?: Date;
  // để giống docsign, ui xử lý, be không cần xử lý
  typesigncustomer?: number;
}

// bước ký==>các bước
export interface ListStepSign {
  id: number;
  key: string;
  idsetupstepsign: number;
  name: string;
  //loai hinh ky
  typesign: string;
  // thông tin người ký
  username: string;
  email: string;
  //bước ký
  numberstep: number;
  //kiểu ký
  typesigncustomer: number;
  roleid?: number;
  // đã ký hay chưa
  issign: number;
  vendorid: number;
  signdate?: Date;
  ekyc?: boolean;
  addstep?: boolean;
  taxcode?: string;
  phone?: string;
  expdate?: number;
  // file lưu lịch sử ký
  filehistorysign: string;
  // bước hiện tại chờ ký
  iscurrent?: boolean;
  // danh sách vị trí cần ký tương ứng với từng trang
  list: SignaturePage[];
  //map o ngoai

  fullName?: string;
}

// setup chi tiết tài liệu sẽ ký==>header
export interface SetupStepSign {
  id: number;
  documentId: number;
  title: string;
  fileUrl: string;
  createBy?: string;
  createDate?: Date;
  lastUpdateBy: string;
  lastUpdateDate?: Date;
  // danh sách vị trí cần ký tương ứng với từng trang
  list: ListStepSign[];
  sampleprocessid?: number;
}

/**
 * Hàm lấy SetupStepSign theo id từ danh sách tài liệu dựa trên SignaturePage
 * @param documentsList Danh sách các tài liệu
 * @param signatureId Id của SignaturePage cần tìm
 * @returns SetupStepSign chứa SignaturePage nếu tìm thấy, ngược lại trả về null
 */
export function findDocumentBySignatureId(
  documentsList: ListStepSign[],
  signatureId: string
) {
  for (const document of documentsList) {
    for (const step of document.list) {
      if (step.key === signatureId) {
        return step;
      }
    }
  }
  return null; // Trả về null nếu không tìm thấy tài liệu với id đã cho
}

export function findListStepSignByKeySignaturePage(
  documentsList: ListStepSign[],
  signatureId: string
): ListStepSign | null {
  for (const document of documentsList) {
    for (const step of document.list) {
      if (step.key === signatureId) {
        return document;
      }
    }
  }
  return null;
}
export const listColor = [
  "#228be6",
  "#6d4b40",
  "#f06418",
  "#fc8c0c",
  "#d9d02f",
  "#6bd731",
  "#2bdd66",
  "#09b8ff",
  "#099cff",
  "#5474b47",
  "#1f32c4",
  "#4f23c0",
  "#504c97",
  "#7b2eda",
  "#8931b2",
  "#f01879",
  "#c91a52",
  "#FF0000", // red
  "#333333", // dark (dark gray)
  "#808080", // gray
  "#FF0000", // red
  "#FFC0CB", // pink
  "#6F2DA8", // grape
  "#8A2BE2", // violet
  "#4B0082", // indigo
  "#0000FF", // blue
  "#00FFFF", // cyan
  "#008000", // green
  "#00FF00", // lime
  "#FFFF00", // yellow
  "#FFA500", // orange
  "#008080", // teal
];
